import { IPage, IPageArticle, TypeNamePageArticle } from '../../interfaces/pages';

export const isArticlePage = (page: IPage): page is IPageArticle => {
  return page.__typename === TypeNamePageArticle;
};
